import { K8sProvider } from '@cast/shared-types';
import {
  AKSCluster,
  AnywhereCluster,
  Cluster,
  EKSCluster,
  GKECluster,
  KopsCluster,
  RosaCluster,
} from '@cast/types';
import { isDemoCluster } from '@cast/utils';

export const isEKSCluster = (cluster: Cluster): cluster is EKSCluster => {
  return cluster.eks !== undefined;
};

export const isGKECluster = (cluster: Cluster): cluster is GKECluster => {
  return cluster.gke !== undefined;
};

export const isAKSCluster = (cluster: Cluster): cluster is AKSCluster => {
  return cluster.aks !== undefined;
};

export const isKOPSCluster = (cluster: Cluster): cluster is KopsCluster => {
  return cluster.kops !== undefined;
};

export const isROSACluster = (cluster: Cluster): cluster is RosaCluster => {
  return cluster.openshift !== undefined;
};

export const isAnywhereCluster = (
  cluster: Cluster
): cluster is AnywhereCluster => {
  return cluster.anywhere !== undefined;
};

export const guessMainProvider = (clusters: Cluster[]): K8sProvider => {
  const clustersByProvider: Record<K8sProvider, number> = {
    [K8sProvider.EKS]: 0,
    [K8sProvider.AKS]: 0,
    [K8sProvider.GKE]: 0,
    [K8sProvider.KOPS]: 0,
    [K8sProvider.ROSA]: 0,
    [K8sProvider.ANYWHERE]: 0,
    [K8sProvider.SELF_HOSTED]: 0,
    [K8sProvider.OKE]: 0,
  };

  clusters.reduce((acc, cluster) => {
    if (!isDemoCluster(cluster.id)) {
      if (isEKSCluster(cluster)) {
        acc.eks += 1;
      }

      if (isAKSCluster(cluster)) {
        acc.aks += 1;
      }

      if (isGKECluster(cluster)) {
        acc.gke += 1;
      }

      if (isKOPSCluster(cluster)) {
        acc.kops += 1;
      }

      if (isROSACluster(cluster)) {
        acc.openshift += 1;
      }

      if (isAnywhereCluster(cluster)) {
        acc.anywhere += 1;
      }
    }

    return acc;
  }, clustersByProvider);

  const provisionedQuantities: number[] = Object.values(clustersByProvider);
  const provisionedProviders = Object.keys(clustersByProvider) as K8sProvider[];

  const maxProviderClusterIndex = provisionedQuantities.indexOf(
    Math.max(...provisionedQuantities)
  );

  return provisionedProviders[maxProviderClusterIndex];
};
